// extracted by mini-css-extract-plugin
export default {"features":"FeaturesSection_features__MkHiu","grid":"FeaturesSection_grid__HsTjj"};